export default "__VITE_ASSET__DnekIll0__"